import React, { useEffect, useRef } from 'react';
import './ElegantBackground.css';

const ElegantShape = ({ 
  className, 
  delay = 0, 
  width = 400, 
  height = 100, 
  rotate = 0, 
  gradient = "indigo"
}) => {
  return (
    <div 
      className={`elegant-shape ${className}`}
      style={{
        animationDelay: `${delay}s`,
        '--shape-width': `${width}px`,
        '--shape-height': `${height}px`,
        '--shape-rotate': `${rotate}deg`,
        '--shape-gradient': gradient
      }}
    >
      <div className="shape-inner"></div>
    </div>
  );
};

const ElegantBackground = () => {
  const glowRef = useRef(null);

  useEffect(() => {
    let targetX = window.innerWidth / 2;
    let targetY = window.innerHeight / 2;
    let currentX = targetX;
    let currentY = targetY;
    let rafId;

    const handlePointerMove = (e) => {
      targetX = e.clientX;
      targetY = e.clientY;
    };

    const animate = () => {
      // Smooth follow (lerp)
      const ease = 0.12;
      currentX += (targetX - currentX) * ease;
      currentY += (targetY - currentY) * ease;
      if (glowRef.current) {
        glowRef.current.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;
      }
      rafId = requestAnimationFrame(animate);
    };

    window.addEventListener('pointermove', handlePointerMove, { passive: true });
    rafId = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('pointermove', handlePointerMove);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div className="elegant-background">
      <div className="gradient-overlay"></div>
      <div className="cursor-glow" ref={glowRef} aria-hidden="true" />
      <div className="shapes-container">
        <ElegantShape
          delay={0.3}
          width={600}
          height={140}
          rotate={12}
          gradient="indigo"
          className="shape-1"
        />

        <ElegantShape
          delay={0.5}
          width={500}
          height={120}
          rotate={-15}
          gradient="rose"
          className="shape-2"
        />

        <ElegantShape
          delay={0.4}
          width={300}
          height={80}
          rotate={-8}
          gradient="violet"
          className="shape-3"
        />

        <ElegantShape
          delay={0.6}
          width={200}
          height={60}
          rotate={20}
          gradient="amber"
          className="shape-4"
        />

        <ElegantShape
          delay={0.7}
          width={150}
          height={40}
          rotate={-25}
          gradient="cyan"
          className="shape-5"
        />

        <ElegantShape
          delay={1.0}
          width={350}
          height={90}
          rotate={8}
          gradient="rose"
          className="shape-6"
        />

        <ElegantShape
          delay={1.2}
          width={250}
          height={70}
          rotate={-18}
          gradient="indigo"
          className="shape-7"
        />
      </div>
      <div className="bottom-gradient"></div>
    </div>
  );
};

export default ElegantBackground;